import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
//import XLSX from 'xlsx'; // Import xlsx library
import * as XLSX from 'xlsx';
import { fetchData, deleteData, activateData, ReportData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Select from 'react-select';
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import ReactPaginate from 'react-paginate';
import CircularProgress from '@mui/material/CircularProgress';
import TablePagination from '@mui/material/TablePagination';
import TableFooter from '@mui/material/TableFooter';

function ExpenseSummeryReport() {
    const [data, setData] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const tableRef = React.createRef();
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, companyId, permissions, token, logout } = useAuth();
    const [routeOptions, setRouteOptions] = useState([]);
    const [selectedRoute, setSelectedRoute] = useState(null);
    const [tripOptions, setTripOptions] = useState([]);
    const [selectedTrip, setSelectedTrip] = useState(null);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState();
    const [routeId, setrouteId] = useState('');
    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 10;


    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, token, logout]);

    const hasReadReportPermission = permissions.includes('Read Reports');




    const handleRefreshClick = (e) => {
        setFromDate(getFirstDayOfMonth());
        setToDate(getCurrentDate());
        // Reload the window after state updates
        window.location.reload();
    };

    const handleFromDateChange = (e) => {
        setFromDate(e.target.value);
    };

    const handleToDateChange = (e) => {
        setToDate(e.target.value);
    };

    const [Corderdate, setCorderdate] = useState("");
    const [orderTakenby, setOrdertakenby] = useState("");
    const [route, setroute] = useState("");
    const [filteredData, setFilteredData] = useState([]);
    const getFirstDayOfMonth = () => {
        const today = new Date();
        return `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-01`;
    };

    const getCurrentDate = () => {
        const today = new Date();
        return `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`;
    };

    useEffect(() => {
        setFromDate(getFirstDayOfMonth());
        setToDate(getCurrentDate());
    }, []);




    useEffect(() => {
        fetchTripTypes();
    }, []);

    const fetchTripTypes = async () => {
        try {
            const response = await fetchData('CustomerOrderedItemAPI', `/${companyId}`, token);

            // Check if response is valid and has data
            if (response.responseCode === '1111' && Array.isArray(response.response_data)) {
                const options = response.response_data.map(trip => ({
                    value: trip.Id,
                    label: trip.Description
                }));
                setTripOptions(options);
            } else {
                console.warn('No trip data found');
            }
        } catch (error) {
            console.error('Error fetching trip types:', error.message);
            // Optionally set an error state here to notify the user
        }
    };


    const [TripId, settripId] = useState('');

    const handleRouteTypeChange = async (selectedOption) => {
        setSelectedTrip(selectedOption);
        settripId(selectedOption.value);

        if (!selectedOption) return; // Early return if no option is selected

        try {
            const response = await fetchData('ExpenseSummery', `/${companyId}/${selectedOption.value}`, token);
            if (response.responseCode === '1111') {
                const dataArray = response.response_data;

                if (dataArray.length > 0) {
                    setData(dataArray);

                    // Update filtered data based on selected trip
                    setFilteredData(dataArray.filter(item => item.route === selectedOption.value));
                }
                console.log(response);
            }
        } catch (error) {
            console.error('Error fetching Customer Details:', error);
        }
    };



    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };


    // Define filteredDataItem within the component
    const filteredDataItem = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );



    const handlePrint = () => {
        const printWindow = window.open('', '_blank');
        printWindow.document.write('<html><head><title>RouteWise Expense Report</title></head><body>');
        printWindow.document.write('<h3 style="font-family: Times New Roman; font-size: 32px;">RouteWise Expense Report</h3>');
        printWindow.document.write('<table style="border-collapse: collapse; width: 100%;">');
        printWindow.document.write('<thead style="background-color: #f3f3f3;">');
        printWindow.document.write('<tr>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Sl.No</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Expense Date</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Sales Executive</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Expense Type</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Expense Remarks</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Odo Meter</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Amount</th>');
        printWindow.document.write('</tr>');
        printWindow.document.write('</thead>');
        printWindow.document.write('<tbody>');

        let lastExpenseDate = null;
        let lastSalesmanName = null;

        data.forEach((rowData, index) => {
            printWindow.document.write('<tr>');
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${index + 1}</td>`);

            // Check if the expense date has changed
            if (lastExpenseDate !== rowData.ExpenseDate || lastSalesmanName !== rowData.SalesmanName) {
                printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${new Date(rowData.ExpenseDate).toLocaleDateString('en-GB')}</td>`);
                printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.SalesmanName}</td>`);
                lastExpenseDate = rowData.ExpenseDate;
                lastSalesmanName = rowData.SalesmanName;
            } else {
                // If the same expense date and salesman, leave these cells empty
                printWindow.document.write('<td style="border: 1px solid #ddd; font-size: 16px;"></td>');
                printWindow.document.write('<td style="border: 1px solid #ddd; font-size: 16px;"></td>');
            }

            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.ExpenseType}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.Note}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.OdoMeter}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.Amount}</td>`);
            printWindow.document.write('</tr>');
        });

        printWindow.document.write('</tbody></table></body></html>');
        printWindow.document.close();
        printWindow.print();
    };


    const handleExportExcel = () => {
        const excelData = [];

        // Add header row
        const headerRow = [
            'Sl.No',
            'Expense Date',
            'Sales Executive',
            'Expense Type',
            'Expense Remarks',
            'Odo Meter',
            'Amount'
        ];
        excelData.push(headerRow);

        // Add data rows with merging logic
        let lastExpenseDate = '';
        let lastSalesExecutive = '';
        let expenseDateCount = 0;
        let salesExecutiveCount = 0;

        data.forEach((rowData, index) => {
            const dataRow = [
                index + 1,
                rowData.ExpenseDate,
                rowData.SalesmanName,
                rowData.ExpenseType,
                rowData.Note,
                rowData.OdoMeter,
                rowData.Amount
            ];

            // Check for merging "Expense Date"
            if (rowData.ExpenseDate === lastExpenseDate) {
                dataRow[1] = ''; // Clear the cell to merge
                expenseDateCount++;
            } else {
                lastExpenseDate = rowData.ExpenseDate;
                expenseDateCount = 1; // Reset count for new date
            }

            // Check for merging "Sales Executive"
            if (rowData.SalesmanName === lastSalesExecutive) {
                dataRow[2] = ''; // Clear the cell to merge
                salesExecutiveCount++;
            } else {
                lastSalesExecutive = rowData.SalesmanName;
                salesExecutiveCount = 1; // Reset count for new executive
            }

            excelData.push(dataRow);
        });

        // Create a worksheet
        const ws = XLSX.utils.aoa_to_sheet(excelData);

        // Merge cells for Expense Date and Sales Executive
        const mergeCells = [];
        let rowIndex = 1; // Start from the first data row
        let prevDate = '';
        let prevExecutive = '';

        data.forEach((rowData) => {
            if (rowData.ExpenseDate === prevDate) {
                mergeCells[mergeCells.length - 1].s.r = rowIndex - 1; // Update start row for previous date
            } else {
                if (mergeCells.length && mergeCells[mergeCells.length - 1].s.r < rowIndex - 1) {
                    mergeCells[mergeCells.length - 1].e.r = rowIndex - 1; // Update end row for previous date
                }
                prevDate = rowData.ExpenseDate;
                mergeCells.push({ s: { r: rowIndex, c: 1 }, e: { r: rowIndex, c: 1 } });
            }

            if (rowData.SalesmanName === prevExecutive) {
                mergeCells[mergeCells.length - 1].s.r = rowIndex - 1; // Update start row for previous executive
            } else {
                if (mergeCells.length && mergeCells[mergeCells.length - 1].s.r < rowIndex - 1) {
                    mergeCells[mergeCells.length - 1].e.r = rowIndex - 1; // Update end row for previous executive
                }
                prevExecutive = rowData.SalesmanName;
                mergeCells.push({ s: { r: rowIndex, c: 2 }, e: { r: rowIndex, c: 2 } });
            }

            rowIndex++;
        });

        // Apply merges
        if (mergeCells.length) {
            ws['!merges'] = mergeCells;
        }

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'RouteWise Expense Report');
        XLSX.writeFile(wb, 'RouteWise Expense Report.xlsx');
    };

    const [page, setPage] = useState(0); // Current page
    const [rowsPerPage, setRowsPerPage] = useState(15); // Rows per page

    // Define initial column order
    const [columnOrder, setColumnOrder] = useState([

        'SL No',
        'Sales Executive',
        'Expense Date ',
        'Expense Type',
        'Expense Remark',
        'Odometer',
        'Amount',
        ''

    ]);
    // Process and paginate the data
    const processedData = filteredDataItem.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );


    // Handle page change
    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    // Handle rows per page change
    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // Reset to the first page
    };

    // Function to handle drag start
    const handleDragStart = (e, index) => {
        e.dataTransfer.setData('columnIndex', index);
    };

    // Function to handle drag over
    const handleDragOver = (e) => {
        e.preventDefault(); // Allow drop
    };
    // Function to handle drop
    const handleDrop = (e, index) => {
        const draggedIndex = e.dataTransfer.getData('columnIndex');
        if (draggedIndex !== index) {
            const newOrder = [...columnOrder];
            // Swap columns
            [newOrder[draggedIndex], newOrder[index]] = [newOrder[index], newOrder[draggedIndex]];
            setColumnOrder(newOrder);
        }
    };



    return (

        <div className="w-full  mt-6 mx-auto custom-scrollbar" style={{ width: '95%', }}>
            <style>
                {`
                    .custom-scrollbar::-webkit-scrollbar {
                        width: 3px;
                    }

                    .custom-scrollbar::-webkit-scrollbar-thumb {
                        background-color: #333;
                        border: 2px solid #555;
                        border-radius: 6px;
                    }

                    .custom-scrollbar::-webkit-scrollbar-track {
                        background-color: #ddd;
                        border-radius: 6px;
                    }
                    `}
            </style>

            <div className="w-full  mx-auto" style={{ marginTop: '-10px' }}>
                <h6 className="uppercase tracking-wide text-black flex-grow linkcolor"
                    style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>EXPENSE ROUTEWISE SUMMARY </h6>


                <div className="flex justify-end">

                    <div className="w-1/4 mr-2" style={{ marginTop: '-10px', marginLeft: '2px' }}>
                        <Select
                            value={selectedTrip}
                            onChange={handleRouteTypeChange}
                            options={tripOptions}
                            placeholder="Select Trip"
                            styles={{
                                menu: (provided) => ({
                                    ...provided,
                                    zIndex: 1301, // Ensure dropdown appears above the sticky header
                                }),
                            }}
                        >
                        </Select>
                    </div>

                    <Button
                        style={{
                            backgroundColor: '#C9E9D2',
                            color: 'black',
                            height: '36px',
                            marginTop: '-10px',
                            marginLeft: '5px'

                        }}
                        onClick={handleRefreshClick}
                        className="linkcolor"
                    >
                        <span>Refresh</span>
                    </Button>
                    <Button
                        style={{
                            backgroundColor: '#F8E8EE',
                            color: 'black',
                            height: '36px',
                            marginTop: '-10px',
                            marginLeft: '5px'

                        }}
                        onClick={handleExportExcel}
                        className="linkcolor"
                    >
                        <span>Excel</span>
                    </Button>
                    <Button
                        style={{
                            backgroundColor: '#E8F3D6',
                            color: 'black',
                            height: '36px',
                            marginTop: '-10px',
                            marginLeft: '5px'

                        }}
                        onClick={handlePrint}
                        className="linkcolor"
                    >
                        <span>Print</span>
                    </Button>
                    

                </div>

                {/* Table display */}
                <div className="mt-6">
                    {loading ? (
                        <CircularProgress />
                    ) : (
                        <React.Fragment>

                            <div className='w-full mb-5 flex' style={{ maxHeight: '540px', overflowY: 'auto', marginTop: '-0.20%' }}>

                                <TableContainer component={Paper}>
                                    <Table>
                                        <TableHead sx={{
                                            backgroundColor: 'teal',
                                            position: 'sticky',
                                            top: 0,
                                            zIndex: 1, width: '2500px'
                                        }}>
                                            <TableRow>
                                                {columnOrder.map((col, index) => (
                                                    <TableCell
                                                        key={index}
                                                        style={{
                                                            padding: '6px',
                                                            cursor: 'move',
                                                            color: 'white',
                                                            fontWeight: 'bold',

                                                        }}
                                                        draggable
                                                        onDragStart={(e) => handleDragStart(e, index)}
                                                        onDragOver={handleDragOver}
                                                        onDrop={(e) => handleDrop(e, index)}
                                                    >
                                                        {col}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {Array.isArray(processedData) && processedData.length > 0 ? (
                                                processedData.map((rowData, index) => {
                                                    let showStaffName = true;
                                                    let showExpenseDate = true;

                                                    // Compare with the previous row
                                                    if (index > 0) {
                                                        const previousRow = processedData[index - 1];
                                                        if (rowData.SalesmanName === previousRow.SalesmanName) {
                                                            showStaffName = false;
                                                        }
                                                        if (rowData.ExpenseDate === previousRow.ExpenseDate) {
                                                            showExpenseDate = false;
                                                        }
                                                    }

                                                    const rowValues = {
                                                        'SL No': index + 1,
                                                        'Sales Executive': showStaffName ? rowData.SalesmanName : '',
                                                        'Expense Date': showExpenseDate
                                                            ? rowData.ExpenseDate
                                                                ? new Date(rowData.ExpenseDate).toLocaleDateString('en-GB')
                                                                : ''
                                                            : '',
                                                        'Expense Type': rowData.ExpenseType || '',
                                                        'Expense Remarks': rowData.Note || '',
                                                        'Odo Meter': rowData.OdoMeter || '',
                                                        'Amount': rowData.Amount ? rowData.Amount.toFixed(2) : '0.00',
                                                        '': '',
                                                    };

                                                    return (
                                                        <React.Fragment key={index}>
                                                            <TableRow
                                                                style={{
                                                                    backgroundColor: rowData.OrderTypeHeading === 'TOTAL' ? '#F5EFE3' : 'inherit',

                                                                }}
                                                            >
                                                                {Object.keys(rowValues).map((key) => (
                                                                    <TableCell
                                                                        key={key}
                                                                        sx={{
                                                                            fontSize: '14px',
                                                                            padding: '5px',
                                                                            textAlign: 'left',
                                                                            width: '20px'

                                                                        }}
                                                                    >
                                                                        {rowValues[key]}
                                                                    </TableCell>
                                                                ))}
                                                            </TableRow>
                                                        </React.Fragment>
                                                    );
                                                })
                                            ) : (
                                                <TableRow>
                                                    <TableCell colSpan={8} sx={{ textAlign: 'center' }}>
                                                        No data available.
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>

                                        {/* Render Grand Total in Footer */}
                                        <TableFooter style={{ padding: '5px' }}>
                                            <TableRow>
                                                <TablePagination
                                                    rowsPerPageOptions={[15, 25, 50, 100]}
                                                    count={filteredDataItem.length}
                                                    rowsPerPage={rowsPerPage}
                                                    page={page}
                                                    onPageChange={handlePageChange}
                                                    onRowsPerPageChange={handleRowsPerPageChange}
                                                />
                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                </TableContainer>
                            </div>
                        </React.Fragment>
                    )}
                </div>

            </div>

        </div >
    );
};
export default ExpenseSummeryReport;
